import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle1 text-bold flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Är du säker på att du vill rapportera avvikelsen som utförd?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    style: {"max-width":"350px"},
    class: "full-width"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_icon, {
              name: "mdi-check-circle-outline",
              class: "q-mr-sm"
            }),
            _createTextVNode(" Rapportera utförd avvikelse ")
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "q-pt-none text-body2 text-grey-8" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            type: "textarea",
            rows: "2",
            disabled: _ctx.deviationUpdateLoading,
            filled: "",
            modelValue: _ctx.completedDescription,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.completedDescription) = $event)),
            label: "Beskrivning",
            placeholder: "Beskriv utförandet..."
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_actions, {
        align: "right",
        class: "text-primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            flat: "",
            label: "Avbryt",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
            disabled: _ctx.deviationUpdateLoading
          }, null, 8, ["disabled"]),
          _createVNode(_component_q_btn, {
            color: "white",
            "text-color": "positive",
            label: "Bekräfta",
            loading: _ctx.deviationUpdateLoading,
            onClick: _ctx.onConfirm
          }, null, 8, ["loading", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}